import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  dataKey: {
    defaultMessage: 'Data Key',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.DataKeySelect.dataKey`,
  },
});
export default messages;
